import { API_URLs } from "../../../../utilities/API_URLs";
import { Http } from "../../../../utilities/axios/http";

export class MissingService {
  static getAllMissing = async (params: any) => {
    try {
      return await Http.get(API_URLs.missing.getAllMissing, params);
    } catch (error) {
      return error;
    }
  };
  static getOneStaff = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.missing.getOneMissing, id);
    } catch (error) {
      return error;
    }
  };
  static createMissing = async (data: any) => {
    try {
      return await Http.post(API_URLs.missing.createMissing, data);
    } catch (error) {
      return error;
    }
  };

  static updateMissing = async (data: any) => {
    try {
      return await Http.patch(API_URLs.missing.updateMissing, data);
    } catch (error) {
      return error;
    }
  };

  static deleteMissing = async (id: number) => {
    try {
      return await Http.delete(API_URLs.missing.deleteMissing, id);
    } catch (error) {
      return error;
    }
  };
}
